import { SurveyQuestion } from '../../../../../../entities/survey_engine/SurveyQuestion';

export function isCustomQuestion(question: SurveyQuestion) {
  // A "custom question" answer will be written to a SurveyEngine::Survey
  // and, hence, will have an associated QuestionField. A "regular" question
  // will have its answer stored on a database column.
  return question.fields.length > 0;
}
